import { useRef, useState } from "react";
import { UseFormReturn, useWatch } from "react-hook-form";

import { EmailRegex } from "../../core/login.core";
import { useTranslation } from "../../core/translation.core";
import CloseIcon from "../../icons/iconClose.comp";
import { FormDefFormData } from "../../types/form";
import { LabelAndInput, LabelAndTextArea } from "../reuseables/form.comp";

export default function FormDefEditor({
  methods,
  onSubmit,
}: {
  methods: UseFormReturn<FormDefFormData, any>;
  onSubmit: (data: FormDefFormData) => void;
}) {
  const { t, msg } = useTranslation();

  const errors = methods.formState.errors;
  const emailFields = ["notifyEmails[0]", "notifyEmails[1]", "notifyEmails[2]"];

  return (
    <form onSubmit={methods.handleSubmit(onSubmit)}>
      <LabelAndInput
        register={methods.register}
        fieldName="code"
        label={t(msg.category.code)}
        registerOptions={{ required: t(msg.form.required) }}
        errors={errors}
      />
      <LabelAndInput
        register={methods.register}
        fieldName="subject"
        label={t(msg.formSubmit.emailSubject)}
        registerOptions={{ required: t(msg.form.required) }}
        errors={errors}
      />

      {emailFields.map((emailField, idx) => (
        <LabelAndInput
          key={idx}
          register={methods.register}
          fieldName={emailField}
          label={`${t(msg.setting.email)} #${idx + 1}`}
          registerOptions={{
            pattern: {
              value: EmailRegex,
              message: t(msg.form.formatInvalid),
            },
            required: idx === 0 ? t(msg.form.required) : false,
          }}
          errors={errors}
        />
      ))}

      <LabelAndTextArea
        register={methods.register}
        fieldName="mailTemplate"
        label={t(msg.mailTemplate.mailTemplate)}
        registerOptions={{ required: t(msg.form.required) }}
        errors={errors}
      />

      <input className="mt-4" type="submit" />
    </form>
  );
}
